<template>
  <div v-html="richData.content" class="content"></div>
</template>

<script>

export default {
  name: 'RichText',
  data () {
    return {
      richData: JSON.parse(sessionStorage.getItem('richText'))
    }
  },
  mounted () {
    console.log(this.richData.appointmentNotice)
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .content {
    padding: 0 20px;
    box-sizing: border-box;
    ::v-deep img {
      max-width: 100%;
      height: auto;
    }
  }
</style>
